import { render, staticRenderFns } from "./QuestionTasting.vue?vue&type=template&id=75008691&scoped=true&"
import script from "./QuestionTasting.vue?vue&type=script&lang=js&"
export * from "./QuestionTasting.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTasting.vue?vue&type=style&index=0&id=75008691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75008691",
  null
  
)

export default component.exports